module.exports = __webpack_public_path__ + "img/celeri.04e2826c.svg";